import React from "react"
import {FormGroup} from "@blueprintjs/core"
import Props from "../../../core/components/props"
import "./FilterOptionPanel.scss"

export interface DoubleInputProps extends Props {
    valueFrom: string
    valueTo: string
    setValueFrom: (value: string) => void
    setValueTo: (value: string) => void
}

const DoubleInput: React.FC<DoubleInputProps> = (props) => {
    return (
        <div style={{display: "flex"}}>
            <FormGroup
                className="CardRowElement"
                inline
                label="between"
                labelFor="from"
            >
                <input
                    style={{width: "50%"}}
                    name="from"
                    value={props.valueFrom}
                    onChange={(e: React.FormEvent<HTMLInputElement>) =>
                        props.setValueFrom(e.currentTarget.value)
                    }
                />
            </FormGroup>
            <FormGroup
                className="CardRowElement"
                inline
                label="to"
                labelFor="to"
            >
                <input
                    style={{width: "50%"}}
                    name="to"
                    value={props.valueTo}
                    onChange={(e: React.FormEvent<HTMLInputElement>) =>
                        props.setValueTo(e.currentTarget.value)
                    }
                />
            </FormGroup>
        </div>
    )
}

export default DoubleInput
